import React, { useEffect, useRef } from 'react';
import { Box, Container, Grid } from '@mui/material';
import Footer from './Footer';
import Breadcrumbs from './WebBreadcrumbs';
import Banner from './Banner';
import { BannerType } from 'types';
import TabsHeader, { tabsOverAllProps } from 'features/eadvisor/application/components/TabsHeader';
import AppBar from 'components/extended/AppBar';
import Announcements from 'features/announcement';
import { useDispatch, useSelector } from 'store';
import { getDropdownOpts } from 'store/slices/application.slice';
import { goScrollTop } from 'utils/windows';
import { getNotification } from 'store/slices/notification';
import useObserver from 'hooks/useObserver';

type Props = {
    bannerProps?: BannerType;
    children: React.ReactNode;
    sideBar?: React.ReactNode;
    tabs?: tabsOverAllProps | null;
    header?: React.ReactNode;
};

// ==============================|| Web LAYOUT ||============================== //

function HomeLayout({ bannerProps, children, sideBar, tabs, header: Header }: Props) {
    const { isLoggedIn } = useSelector((state) => state.account);
    const dispatch = useDispatch();
    const [containerRef, isVisible] = useObserver();

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(getNotification());
        }
    }, [isLoggedIn]);

    useEffect(() => {
        // if (Object.keys(dropdownOpts).length === 0) {
        dispatch(getDropdownOpts());
        goScrollTop();
        // }
    }, []);

    return (
        <>
            <AppBar Header={Header} isVisible={isVisible} />
            <Box style={{ minHeight: '100vh', background: bannerProps?.isLogin ? '#FFFFFF' : '#F7F7F7' }}>
                {window.location.pathname === '/' && <Announcements />}
                {String(bannerProps?.type) === 'page404' ? null : <Breadcrumbs />}
                {!!bannerProps && <Banner {...bannerProps} />}
                {!!Header && (
                    <Container
                        ref={containerRef}
                        sx={{
                            background: '#fff!important',
                            display: {
                                xs: 'block',
                                lg: 'none'
                            }
                        }}
                    >
                        {Header}
                    </Container>
                )}
                {!!tabs && (
                    <Container>
                        {' '}
                        <TabsHeader {...tabs} />
                    </Container>
                )}
                {sideBar ? (
                    <Container>
                        <Grid container>
                            {!!sideBar && (
                                <Grid item xs={12} lg={3}>
                                    {sideBar}
                                </Grid>
                            )}
                            <Grid item xs={12} lg={sideBar ? 9 : 12}>
                                {children}
                            </Grid>
                        </Grid>
                    </Container>
                ) : (
                    children
                )}
            </Box>
            <Footer />
        </>
    );
}

export default HomeLayout;
